export default __webpack_public_path__ + "static/media/win2k22.de0e1157.png";